import React, { memo, ChangeEvent } from 'react'
import { Checkbox } from 'transfix-ui/components/Checkbox'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TIME_INPUT_FORMAT, TimeInput } from 'transfix-ui'

interface IIsSameDayProps {
  value: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  dataTest?: string
}

export const IsSameDay = memo<IIsSameDayProps>(({ dataTest, onChange, value }) => {
  const { isSameDay, ruleStartTimeCriteria } = value

  const isSameDayChangeHandler = ({ target: { checked } }: ChangeEvent<HTMLInputElement>) => {
    if (checked) {
      onChange({
        isSameDay: checked,
        ruleStartTimeCriteria: {
          ...ruleStartTimeCriteria,
        },
      })
    } else {
      onChange({
        isSameDay: checked,
        ruleStartTimeCriteria: undefined,
      })
    }
  }
  const changeTimeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      ruleStartTimeCriteria: {
        ...ruleStartTimeCriteria,
        rangeStart: value,
      },
    })
  }
  const showStopSpecificCheckbox = isSameDay

  return (
    <div className='row' data-test={dataTest}>
      <div className='w-100 col-md-6 col-xs-6'>
        <Checkbox label='Is Same Day?' checked={isSameDay} onChange={isSameDayChangeHandler} />
      </div>
      {showStopSpecificCheckbox && (
        <div className='col-md-6 col-xs-6'>
          <TimeInput
            label='Rule Start Time (EST)'
            placeholder='Optional'
            value={ruleStartTimeCriteria?.rangeStart || ''}
            onChange={changeTimeHandler}
            large
            timeFormat={TIME_INPUT_FORMAT.MILITARY}
          />
        </div>
      )}
    </div>
  )
})
